import React, { useState } from 'react'
import { Button, useTraversal } from '@guillotinaweb/react-gmi'
import { message } from 'antd'
import { JSONEditor } from './json_editor'

export function QueryProducts({ title, query, onChange }) {
  const Ctx = useTraversal()
  const [jsonError, setJsonError] = useState(false)
  const [queryResults, setQueryResults] = useState()

  async function test_query() {
    const q = { ...query }
    // transform i18n fields
    for (let field in q)
      if (field.startsWith('%') && field.endsWith('%'))
        q[field.substring(1, field.length - 1)] = q[field]['es']
    const [status, json] = await Ctx.client.getProducts(q, 'es')
    if (status === 200) setQueryResults(json)
    else message.error('error: ' + JSON.stringify(json))
  }

  return (
    <>
      {title && <label className="label">{title}</label>}
      <JSONEditor
        value={query}
        onChange={(error, v) => {
          setJsonError(error)
          if (!error) onChange(v)
        }}
      />
      <Button disabled={jsonError} onClick={test_query}>
        Test query
      </Button>
      <pre>
        {queryResults &&
          queryResults.search.map((p) => `${p.opciones[0].id} - ${p.nombre}\n`)}
      </pre>
    </>
  )
}
